import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/6-nokta-lifting-nedir-yuz-genclestirmede-yeni-nesil-teknik/page.tsx");
